import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    background: {
      default: "#EDEAE3",
      paper: "#EDE9E1",
    },
    text: {
      primary: "#2C2A26",
      secondary: "#5A5548",
      disabled: "#9A9080",
    },
    divider: "#D5D0C8",
    primary: {
      main: "#2C2A26",
      contrastText: "#EDEAE3",
    },
    secondary: {
      main: "#B5A898",
    },
  },
  typography: {
    fontFamily: "'PT Serif', Georgia, serif",
    h1: { fontFamily: "'Marcellus', Georgia, serif", fontWeight: 300 },
    h2: { fontFamily: "'Marcellus', Georgia, serif", fontWeight: 300 },
    h3: { fontFamily: "'Marcellus', Georgia, serif", fontWeight: 300 },
    h4: { fontFamily: "'Marcellus', Georgia, serif", fontWeight: 300 },
    h5: { fontFamily: "'Marcellus', Georgia, serif", fontWeight: 300 },
    h6: { fontFamily: "'Marcellus', Georgia, serif", fontWeight: 300 },
    fontSize: 15,
  },
  shape: {
    borderRadius: 2,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          textTransform: "none",
          fontFamily: "'PT Serif', Georgia, serif",
          fontSize: 13,
          letterSpacing: "0.04em",
          padding: "10px 28px",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
        @import url('https://fonts.googleapis.com/css2?family=Marcellus&family=PT+Serif:ital,wght@0,400;0,700;1,400;1,700&display=swap');
      `,
    },
  },
});

export default theme;
